import React from "react";
import { useState } from "react";
import './styles/OlvidoContrasenna.css'
import Swal from 'sweetalert2';

let baseUrl;
if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
else baseUrl='https://app-formacion.vercel.app';

function OlvidoSuContraseña() {
  const [email, setEmail] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [enviado, setEnviado] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const res = await fetch(`${baseUrl}/api/users/enviarReestablecimiento`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    const data = await res.json();
    setMensaje(data.message);
    if (res.ok){
      setEnviado(true);
      setTimeout(() => {
        window.location.href = `/ReestablecerContrasenna?email=${encodeURIComponent(email)}`;
      }, 1000);
    }
    else{
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Ha ocurrido un error.',
        confirmButtonText: 'Aceptar'
      });
      return;
    }
  };

  return (
    <div className='olvidoContForm'>
      <div className='olvidoContWrapper'>
        <h2>¿Olvidaste tu contraseña?</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Escribe el correo registrado"
            className="input-boxOC"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <button type="submit" disabled={enviado}>Enviar enlace</button>
        </form>
        {mensaje && <p>{mensaje}</p>}
        {enviado && (
          <p style={{ color: "green" }}>
            Si el correo está registrado, recibirás un código en breve.
          </p>
        )}
      </div>
    </div>
  );
}

export default OlvidoSuContraseña;